import React from 'react';
import { Field } from "@progress/kendo-react-form";
import { Input, MaskedTextBox } from "@progress/kendo-react-inputs";
import Component from '../MgyComponent';
import { Error } from "@progress/kendo-react-labels";

export default function MgyInputField({className, label, type, name, placeholder, masked, disabled, component, onKeyPress, defaultValue, validator, ...rest}) {

    // defaults
    masked = masked ?? false;
    validator = validator ?? (() => { return ''; });

    return <Component tpl = {({...rest}) => { return <div {...rest}/> }}
                   className = {"mgy-input-field " + (className ?? '')}
                   {...rest}>

                <Field type = {type ?? 'text'} className={"mgy-field " + (className ?? '')}
                       name = {name ?? ''}
                       validator = { validator ?? (() => { return '';}) }
                       component = { masked ?
                           (props) => <MaskedTextBox disabled={disabled} {...props } />
                           : (component ? component : (fieldRenderProps) => {
                                const { validationMessage, visited, ...others } = fieldRenderProps;
                                return (
                                    <div>
                                        {visited && validationMessage && <Error>{validationMessage}</Error>}
                                        <label className={"mgy-input-label " + (className ?? '')}>{label}</label>
                                        <Input {...rest} {...others} />
                                    </div>
                                );
                            })
                       }
                       label = { placeholder ?? ''}
                       disabled = { disabled }
                />
            </Component>
}
// <Input disabled={disabled}
//                                             defaultValue={defaultValue} {...props }/>